var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3763 7.3702L6.3102 14.4363L6.00519 17.334C5.95435 17.7152 6.28478 18.0457 6.66605 17.9948L9.56367 17.6898L16.6298 10.6237L13.3763 7.3702ZM18.6378 6.88727L17.1127 5.3622C16.6552 4.87927 15.8673 4.87927 15.3843 5.3622L13.9609 6.7856L17.2144 10.0391L18.6378 8.61567C19.1207 8.13274 19.1207 7.34479 18.6378 6.88727Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4d2249569bf21547a1141adf7db34b86.svg";
export { ForwardRef as ReactComponent };